module.exports = __webpack_public_path__ + "assets/img/11_750_big.09557eb0.jpg";